document.addEventListener("DOMContentLoaded", function () {
  // Render JSON data for various elements
  renderJsonData("reid-data-specifications", renderSpecificationsTable);
  renderJsonData("reid-data-assembly", renderAssemblyTable);
  renderJsonData("reid-data-geometry", renderGeometryTable);
  renderJsonData("reid-data-products", renderProductsData);
  renderJsonData("reid-data-size-guide", renderSizeGuideData);
    renderJsonData("reid-data-features", renderFeatures);

  // Render JSON data based on the provided element ID and a rendering function
  function renderJsonData(elementId, renderFunction) {
    var metafieldElement = document.getElementById(elementId);
    if (metafieldElement) {
      try {
        var jsonData = JSON.parse(metafieldElement.textContent);
        console.log(`Parsed JSON data for ${elementId}:`, jsonData);
        renderFunction(jsonData, elementId);
      } catch (error) {
        console.error(`Error parsing JSON for ${elementId}:`, error);
      }
    } else {
      console.log(`No metafields found for ${elementId}.`);
    }
  }

// Render Features table
   function renderFeatures(data, containerId) {
  var featHTML = "";
   data.productFeatures.forEach((step) => {
featHTML += `
<div class="reid-product-icon-block">
      <div class="reid-product-icon_icon"><i class="${step.icon}"></i></div>
      <div class="reid-product-icon_heading">${step.heading}</div>
      <div class="reid-product-icon_text">${step.text}</div>
      </div>
    `;
});
 var container = document.getElementById("reid-features");
if (container) {
      container.innerHTML = featHTML;
    }
}

  // Render specifications table
  function renderSpecificationsTable(data, containerId) {
    var tableHTML = "";

    for (var category in data) {
      if (
        data.hasOwnProperty(category) &&
        category !== "_id" &&
        category !== "model_code"
      ) {
        var categoryTitle = titleCase(category.replace(/_/g, " "));
        var categoryContainerClass = `${category}-container`;
        var customTableClass = `${category}-table specifications-table`;

        tableHTML += `<div class="${categoryContainerClass}"><h3>${categoryTitle}</h3>`;

        if (typeof data[category] === "object") {
          tableHTML += `<table class="${customTableClass}">`;
          for (var key in data[category]) {
            if (data[category].hasOwnProperty(key)) {
              var keyTitle = titleCase(key.replace(/_/g, " "));
              tableHTML += `<tr><th>${keyTitle}</th><td>${data[category][key]}</td></tr>`;
            }
          }
          tableHTML += "</table>";
        } else {
          tableHTML += `<p>${data[category]}</p>`;
        }

        tableHTML += "</div>";
      }
    }

    var container = document.getElementById("table-specifications");
    var containerMobile = document.getElementById(
      "table-specifications-mobile"
    );
    if (container) {
      container.innerHTML = tableHTML;
    }
     if (containerMobile) {
      containerMobile.innerHTML = tableHTML;
    }
  }

  // Render assembly table
  function renderAssemblyTable(data, containerId) {
    if (!data.steps || data.steps.length === 0) {
      console.log(`No assembly steps found in ${containerId}.`);
      return;
    }

    var assemblyHTML = '<div class="assembly-steps" id="assemblySteps">';

    data.steps.forEach((step) => {
      const videoId = extractYouTubeID(step.url);
      assemblyHTML += `
        <div class="assembly-step">
          <h4 class="step-title">${escapeHTML(step.title)}</h4>
          <p class="step-description">${escapeHTML(step.description)}</p>
          ${
            videoId
              ? `<iframe class="step-video" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>`
              : ""
          }
        </div>
      `;
    });

    assemblyHTML += "</div>";

    var container = document.getElementById("table-assembly");
    var containerMobile = document.getElementById("table-assembly-mobile");
    if (container) {
      container.innerHTML = assemblyHTML;
    }
    if (containerMobile) {
      containerMobile.innerHTML = assemblyHTML;
    }
  }

  // Helper function to escape HTML entities
  function escapeHTML(str) {
    return str.replace(/[&<>'"]/g, function (match) {
      switch (match) {
        case "&":
          return "&amp;";
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case "'":
          return "&#39;";
        case '"':
          return "&quot;";
        default:
          return match;
      }
    });
  }

  // Helper function to extract YouTube video ID from URL
  function extractYouTubeID(url) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
      return match[2];
    } else {
      return null;
    }
  }

  // Render geometry table
  function renderGeometryTable(data, containerId) {
    if (!Array.isArray(data) || data.length === 0) {
      console.log(`No geometry data found in ${containerId}.`);
      return;
    }

    // Dynamically generate table headers based on the keys of the first object, excluding 'size'
    var firstItemKeys = Object.keys(data[0]).filter(
      (key) => key !== "size" && key !== "_id" && key !== "model_code"
    );
    var tableHTML = `<table class="geometry-table"><thead><tr><th>Size</th>`;
     const ORDER = ['x small','small (38cm)','small','medium (43cm)','medium','large (48cm)','large','extra large (53cm)','x large'];

data = data.sort((a, b) => {
debugger;
 a= a.size; b=b.size;

 a = a.toLowerCase();
    b = b.toLowerCase();
    
    let nra = parseInt(a);
    let nrb = parseInt(b);
    
    if ((ORDER.indexOf(a)!=-1)) nra = NaN;
    if ((ORDER.indexOf(b)!=-1)) nrb = NaN;
  
    if (nrb===0) return 1;
    if (nra&&!nrb || nra===0) return -1;
    if (!nra&&nrb) return 1;
    if (nra && nrb) {
        if (nra==nrb) {
            return (a.substr((''+nra).length)).localeCompare((a.substr((''+nra).length)));
        } else {
            return nra-nrb;
        }
    } else {
        return ORDER.indexOf(a) - ORDER.indexOf(b);
    }


});
    

    data.forEach((item) => {
      tableHTML += `<th>${escapeHTML(item.size)}</th>`;
    });
    tableHTML += `</tr></thead><tbody>`;

    // Generate table rows for each size
    firstItemKeys.forEach((key) => {
      tableHTML += `<tr><td class="god">${camelCaseToTitle(key)}</td>`;
      data.forEach((item) => {
        tableHTML += `<td>${escapeHTML(item[key].toString())}</td>`;
      });
      tableHTML += `</tr>`;
    });

    tableHTML += `</tbody></table>`;

    var container = document.getElementById("table-geometry");
     var containerMobile = document.getElementById("table-geometry-mobile");
    if (container) {
      container.innerHTML = tableHTML;
    }
     if (containerMobile) {
      containerMobile.innerHTML = tableHTML;
    }
  }

  // Helper function to convert camelCase to Title Case
  function camelCaseToTitle(str) {
    // Handle specific patterns like "RC", "BB", or any two-letter words
    const specialCases = ["RC", "BB"];
    let isSpecialCase = false;

    // Check for special cases at the beginning of the string
    specialCases.forEach((caseItem) => {
      if (str.startsWith(caseItem.toLowerCase())) {
        str = caseItem + str.slice(2);
        isSpecialCase = true;
      }
    });

    // Replace underscores with spaces
    str = str.replace(/_/g, " ");

    if (!isSpecialCase) {
      // Insert spaces before capital letters (not at the start of the string)
      str = str.replace(/([A-Z][a-z]+)/g, " $1").trim();
    }

    // Convert to Title Case
    return str.replace(/\b\w/g, function (s) {
      return s.toUpperCase();
    });
  }

  // Render product data
  function renderProductsData(data, containerId) {
    if (typeof data !== "object" || data === null) {
      console.log(`No product data found in ${containerId}.`);
      return;
    }

    // Exclude certain keys that are not needed for display
    const excludedKeys = new Set(["_id", "model_code"]);

    var productHTML = '<div class="product-details">';

    Object.keys(data).forEach((key) => {
      if (!excludedKeys.has(key)) {
        productHTML += `
          <div class="product-detail">
            <strong class="detail-title">${camelCaseToTitle(key)}:</strong>
            <span class="detail-value">${escapeHTML(
              data[key].toString()
            )}</span>
          </div>
        `;
      }
    });

    productHTML += "</div>";

    var container = document.getElementById("table-products");
    if (container) {
      container.innerHTML = productHTML;
    }
  }

  function renderSizeGuideData(data, containerId) {
    if (!Array.isArray(data) || data.length === 0) {
      console.log(`No size guide data found in ${containerId}.`);
      return;
    }

    // Get the container element for rendering the chart
    const container = document.getElementById("chart-size-guide");
    const containerMobile = document.getElementById("chart-size-guide-mobile");
    if (!container) {
      console.error(`Container "${containerId}" not found.`);
      return;
    }
     if (!containerMobile) {
      console.error(`Container "${containerId}" not found.`);
      return;
    }

    // Render the size guide table
    let tableHTML = `<table class="size-guide-table"><thead><tr><th>Size</th><th>Range (cm)</th><th>Range (ft & in)</th></tr></thead><tbody>`;
    let barsHTML = "";
    const maxUpper =
      Math.ceil((Math.max(...data.map((item) => item.upper_cm)) + 1) / 10) * 10;
    const minLower =
      Math.floor((Math.min(...data.map((item) => item.lower_cm)) - 1) / 10) *
      10;
    const fullRange = maxUpper - minLower;


    const ORDER = ['x small','small(38cm)','small','medium(43cm)','medium','large(48cm)','large','extra large(53cm)','x large'];

data = data.sort((a, b) => {
debugger;
 a= a.size; b=b.size;

 a = a.toLowerCase();
    b = b.toLowerCase();
    
    let nra = parseInt(a);
    let nrb = parseInt(b);
    
    if ((ORDER.indexOf(a)!=-1)) nra = NaN;
    if ((ORDER.indexOf(b)!=-1)) nrb = NaN;
  
    if (nrb===0) return 1;
    if (nra&&!nrb || nra===0) return -1;
    if (!nra&&nrb) return 1;
    if (nra && nrb) {
        if (nra==nrb) {
            return (a.substr((''+nra).length)).localeCompare((a.substr((''+nra).length)));
        } else {
            return nra-nrb;
        }
    } else {
        return ORDER.indexOf(a) - ORDER.indexOf(b);
    }


});


    

    data.forEach((item, index) => {
      const rangeCm = `${item.lower_cm} - ${item.upper_cm}`;
      const rangeFtIn = `${cmToFtIn(item.lower_cm)} - ${cmToFtIn(
        item.upper_cm
      )}`;
      tableHTML += `<tr><td>${item.size}</td><td>${rangeCm}</td><td>${rangeFtIn}</td></tr>`;

      const barLength = ((item.upper_cm - item.lower_cm) / fullRange) * 100;
      const barStart = ((item.lower_cm - minLower) / fullRange) * 100 - index;

      const lef = barStart * 2;

      barsHTML += `<tr><td></td> </tr></tbody><div class='size-guide-bar' style='display: none; margin-left: ${barStart}%; width: ${barLength}%;'>
      <span class='bar-label' style='position: absolute; left: 0;'>${item.lower_cm}</span>
      <span class='bar-label' style='position: absolute; right: 0;'>${item.upper_cm}</span>
     <span class='bar-label label${index}' style='color:black;position: absolute; left: 50%; transform: translateX(-50%);'>${item.size}</span>
    </div>`;
    });

    let scaleHTML =
    // "<div class='size-guide-scale' style='display: flex; justify-content: space-between; margin-top: 20px; padding-left: 5%;'>";

      "<div class='size-guide-scale' style='display: none; justify-content: space-between; margin-top: 20px; padding-left: 5%;'>";
    for (let i = minLower; i <= maxUpper; i += 10) {
      scaleHTML += `<span class='scale-label'>${i}</span>`;
    }
    scaleHTML += "</div>";

    // Set the inner HTML of the container to include the chart and the scale
    container.innerHTML = scaleHTML + barsHTML;
  containerMobile.innerHTML = scaleHTML + barsHTML;
    // Set the table HTML to a separate container with the ID "table-size-guide"
    var tableContainer = document.getElementById("table-size-guide");
    var tablecontainerMobile = document.getElementById(
      "table-size-guide-mobile"
    );
    if (tableContainer) {
      tableContainer.innerHTML = tableHTML;
       console.log(tableHTML);
    }
    if (tablecontainerMobile) {
      tablecontainerMobile.innerHTML = tableHTML;
       console.log(tableHTML);
    }
  }

// Helper function to convert centimeters to feet and inches
function cmToFtIn(cm) {
  const totalInches = cm / 2.54;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);
  
  if (inches === 12) {
    return `${feet + 1}'0"`;
  }
  
  return `${feet}'${inches}"`;
}

  // Helper function to convert a string to Title Case
  function titleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }
});